module.exports = __webpack_public_path__ + "static/media/mar-del-plata-title.0ae64000.webp";